import React from 'react'
import ContactForm from './ContactForm'
import { ContactWrapper } from './Styled'
import { Col, Container, Row } from 'react-bootstrap'
import { TextButton, TextWithIcon } from '../../../ui/CustomElements'
import { Box, MainHeading, SpanStyled, SubHeadingStyled, TextStyled, } from '../../../ui/Elements'
import { ContactEmail, ContactInstagram, ContactLinkedin, ContactPhone, ContactX, LinkedIn, SnapChat, Tiktok } from '../../../ui/AllImages'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { trackSnapWhatsAppClick, waMessage } from '../../../services/snapPixel'
// import Footer from '../../footer/Footer'

const Contact = () => {
	const WhatsApp = () => {
        const phoneNumber = '+966560532519';
        const message = waMessage();
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        trackSnapWhatsAppClick('contact_section');
        window.open(whatsappURL, '_blank');
    };
	const Map = ""
	const { t } = useTranslation();
	const socialIcon = [
		{
            img: <ContactInstagram />,
            link: 'https://www.instagram.com/soladecor.sa?igsh=MTM1MjA0dmE3ZXhxaA%3D%3D&utm_source=qr',
        },
        // {
        //     img: <ContactX />,
        //     link: 'https://x.com/',
        // },
		{
            img: <Tiktok />,
            link: 'https://www.tiktok.com/@user3666835522780?_t=ZS-8ztPKClli3p&_r=1',
        },
		{
            img: <SnapChat />,
            link: 'https://snapchat.com/t/HhOQoMTg',
        },
        // {
        //     img: <ContactLinkedin />,
        //     link: 'https://www.linkedin.com/',
        // },
    ]
	return (
		<>
			<ContactWrapper id='contact' className='contact-bg container-fluid'>

				<Container>
					<Box className='containerContact'>
						<Row>
							<Col lg={8} md={12} className='contact-Us-detail'>
								<Box className='contect-with-us'>
									<Box className='contactHeadings'>
										<MainHeading className='main-heading main-heading-sub' size="32px" color="var(--secondaryColor)">
											{t('ContactH')}
										</MainHeading>
										<MainHeading className='main-heading mb-4'>
											{t('GetyourFreeQuoteToday')}
										</MainHeading>
									</Box>
									<ContactForm />
								</Box>
							</Col>
							<Col lg={4} md={12} className='contact-Us'>
								<Box className='contactDetailCol'>
									<Box className='contactComBox'>
										<Box className='contactComHeading'>
											{t('Address')}
										</Box>
										<SpanStyled className='d-flex addrTxt' family="var(--medium)" color='var(--bg2)'>
											{t('AddressTxt')}
										</SpanStyled>
									</Box>
									<Box className='contactComBox'>
										<Box className='contactComHeading'>
											{t('Contact')}
										</Box>
										<Box className='contact-info'>
											<TextButton clName="dgts" icon={ContactPhone} label='+966 56 053 2519' onClick={WhatsApp} color="var(--black)" />
											<TextWithIcon icon={ContactEmail} title='info@soola.com' href="mailto:info@soola.com" color="var(--black)" />
										</Box>
									</Box>
									<Box className='contactComBox no-border'>
										<Box className='contactComHeading'>
											{t('StayConnected')}
										</Box>
										<Box className='Social-links'>
											{
												socialIcon.map((list, key) => (
													<a href={list.link} target="_blank" key={key} className='contact-links'>
														{list.img}
													</a>
												))
											}
										</Box>
									</Box>

									
								</Box>
								
								
								
							</Col>
							
						</Row>
					</Box>
				</Container>

			</ContactWrapper>
		</>
	)
}

export default Contact